
define('inlineSvg!svgs/icon/market-same', function () {return '<span class="inline-market-same inline-icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11"><path d="M15 1.03L13.97 0H1L0 1l7 4h.958L15 1.016zM0 9.97L1.03 11H14l1-1-7-4h-.958L0 9.984z" fill="#333"/></svg></span>';});

